import { Component, NgZone, OnInit } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import {
  FormGroup,
  FormBuilder,
  Validators,
  NgForm,
  FormControl,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from "@angular/router";
import { error } from "console";
import { ApplicationService } from "src/app/core/services/application.services";
import { GoogleAuthService } from "src/app/core/services/google-auth.service";
import { JwtService } from "src/app/core/services/jwt.service";
import { UserDataService } from "src/app/core/services/user-data.service";
import { UserService } from "src/app/core/services/user.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  extractedErrorMessage: any;

  hide = true;
  submitted = false;
  loginForm: FormGroup;

  isLoadingCheck = false;
  isLoading: boolean = false;
  isDisabledCheck: boolean = false;
  isLoadingGoogle: boolean = false;

  loginProvider: any;

  actionCode: any;

  mode: any;

  userData: any;
  userFirstNameGoogle: any;
  userLastNameGoogle: any;

  errorMessagePassword: any;

  passwordControl: any;

  workPASStokenExist: boolean = false;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private jwt: JwtService,
    private userService: UserService,
    private userDataService: UserDataService,
    private googleAuthService: GoogleAuthService,
    private _ngZone: NgZone,
    private afAuth: AngularFireAuth,
    private route: ActivatedRoute,
    private googleService: GoogleAuthService,
    private applicationService: ApplicationService
  ) {}

  ngOnInit(): void {
    const token = localStorage.getItem("workpass_token");

    // if (token) {
    //   this.router.navigate(["/user/applicant-profilling"]);
    // } else {
    //   [this.router.navigate(["/login"])];
    // }

    this.loginForm = this.fb.group({
      Email: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern(".*\\.com$"),
        ],
      ],
      // Password: ["", [Validators.required, Validators.minLength(8)]],
      Password: [""],
    });

    this.route.queryParamMap.subscribe((params) => {
      this.mode = params.get("mode");
      this.actionCode = params.get("oobCode");

      localStorage.setItem("mode", this.mode);
      localStorage.setItem("actionCode", this.actionCode);

      switch (this.mode) {
        case "resetPassword":
          this.googleAuthService
            .verifyPasswordResetCode(this.actionCode)
            .then(() => {

              this.router.navigate(["/new-password"]);
            })
            .catch((error) => {
              const errorCode = error.message.split("(")[1].split(")")[0];

              switch (errorCode) {
                case "auth/invalid-action-code":
                  this.router.navigate(["/expired-link"]);
              }
            });

          break;

        case "verifyEmail":
          this.googleAuthService
            .handleVerifyEmail(this.actionCode)
            .then(() => {
              this.router.navigate(["/verify-success"]);
            })
            .catch((error) => {
              const errorCode = error.message.split("(")[1].split(")")[0];

              switch (errorCode) {
                case "auth/invalid-action-code":
                  this.router.navigate(["/expired-link"]);
              }
            });
      }
    });

    this.passwordControl = this.loginForm.get("Password") as FormControl;
  }

  navigate() {
    this.router.navigate(["/signup"]);
  }

  onNavigateLogin() {
    this.router.navigate(["/login"]);
  }

  tryGoogle() {
    this.googleAuthService.GoogleAuth().then((result) => {
      this._ngZone.run(() => {
        const userData = {
          idToken: result.user._delegate.accessToken,
          firstName: result.additionalUserInfo.profile.given_name,
          lastName: result.additionalUserInfo.profile.family_name,
        };

        this.userFirstNameGoogle = userData.firstName;
        this.userLastNameGoogle = userData.lastName;

        this.isLoadingGoogle = true;

        this.userService.googleLogin(userData).subscribe((response) => {

          const workpass_token = response.data.token;

          this.jwt.saveToken(workpass_token);

          this.userService
            .getApplicantDetails(response.data.id)
            .subscribe((response) => {

              this.userData = response;

              if (this.userData.loginProvider === 0) {
                const updatedUserData = { ...this.userData };

                updatedUserData.loginProvider = 2;

                this.userService
                  .updateApplicantDetails(updatedUserData)
                  .subscribe(() => {

                    localStorage.setItem("userID", response.id.toString());
                    localStorage.setItem(
                      "applicantDetails",
                      JSON.stringify(updatedUserData)
                    );

                    if (response.isProfileComplete == false) {
                      this.router.navigate(["/user/applicant-profilling"]);

                      this.isLoadingGoogle = false;
                    } else {
                      this.router.navigate(["/user/home"]);

                      this.isLoadingGoogle = false;
                    }
                  });
              } else {
                localStorage.setItem("userID", response.id.toString());
                localStorage.setItem(
                  "applicantDetails",
                  JSON.stringify(response)
                );

                if (response.isProfileComplete == false) {
                  this.router.navigate(["/user/applicant-profilling"]);

                  this.isLoadingGoogle = false;
                } else {
                  this.router.navigate(["/user/home"]);

                  this.isLoadingGoogle = false;
                }

                this.isLoadingGoogle = false;
              }
            });
        });
      });
    });
  }

  onEnterKey(event: KeyboardEvent) {
    event.preventDefault();

    this.signIn();
  }

  signIn() {
    this.isLoading = true;
    this.isDisabledCheck = true;

    const credentials = {
      Email: this.loginForm.value.Email,
      Password: this.loginForm.value.Password,
    };

    // Check validity of form
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.isLoadingCheck = true;

      // Check if login provider has been already determined
      if (this.loginProvider === undefined) {
        this.userService.getLoginProvider(credentials.Email).subscribe(
          (result) => {
            this.isLoading = true;
            this.loginProvider = result.loginProvider;

            if (this.loginProvider == 2) {
              // Google signup
              this.isDisabledCheck = false;
              this.isLoading = false;

              return;
            } else {
              // Form sign-up
              this.isLoading = false;
              this.isDisabledCheck = false;
            }
          },
          () => {
            this.isLoading = false;

            Swal.fire({
              position: "center",
              icon: "error",
              title: "User cannot be found",
              showConfirmButton: false,
              showCloseButton: true,
            }).then(() => {
              this.isLoading = false;
              this.isLoadingCheck = false;
              this.isDisabledCheck = false;
            });
          }
        );
      } else {

        this.isDisabledCheck = false;

        this.loginWithForm(credentials);
      }
    } else {
      const email = this.loginForm.get("Email").hasError("pattern");

      if (email == true) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please input a valid email",
          showCloseButton: true,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please fill all fields",
          showCloseButton: true,
          showConfirmButton: false,
        });
      }

      // this.loginForm.markAllAsTouched();
      this.isLoading = false;
      this.isDisabledCheck = false;
    }
  }

  loginWithForm(credentials) {
    this.isDisabledCheck = true;

    this.googleAuthService
      .SignIn(credentials.Email, credentials.Password)
      .then((result) => {

        this.isLoading = true;
        this.isDisabledCheck = true;

        if (!result.user.emailVerified) {
          // Email not verified

          Swal.fire({
            position: "center",
            icon: "error",
            title: "Email has not been verified",
            text: "Click button below to send verification link.",
            confirmButtonText: "Send email verification",
            showCloseButton: true,
            allowOutsideClick: false,
            cancelButtonText: "Cancel",
          }).then((result) => {
            if (result.isConfirmed) {
              this.userService
                .resendEmailVerification(credentials.Email)
                .subscribe(
                  (result) => {

                    this.isLoading = true;
                    this.isDisabledCheck = false;

                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Verification email has been sent",
                      text: "Please check your email and click on the link sent to verify your account",
                      showCloseButton: true,
                      confirmButtonText: "Resend verification link",
                      didOpen: () => {
                        const confirmButton = Swal.getConfirmButton();
                        const loaderIcon = document.createElement("span");
                        loaderIcon.classList.add("loader-icon");
                        confirmButton.parentNode.insertBefore(
                          loaderIcon,
                          confirmButton.nextSibling
                        );

                        Swal.disableButtons();

                        let remainingTime = 120;
                        const timerInterval = setInterval(() => {
                          remainingTime--;
                          const minutes = Math.floor(remainingTime / 60);
                          const seconds = remainingTime % 60;
                          confirmButton.innerHTML = `Resend verification link (${minutes}:${seconds
                            .toString()
                            .padStart(2, "0")})`;

                          if (remainingTime <= 0) {
                            clearInterval(timerInterval);
                            confirmButton.innerHTML =
                              "Resend verification link";
                            Swal.enableButtons();
                            loaderIcon.style.display = "none";
                          }
                        }, 1000);

                        const closeButton =
                          document.querySelector(".swal2-close");
                        closeButton.addEventListener("click", () => {
                          this.isLoading = false;
                          this.isDisabledCheck = false;
                        });

                        confirmButton.addEventListener("click", () => {
                          this.isLoading = true;
                          this.isDisabledCheck = false;

                          this.userService

                            .resendEmailVerification(credentials.Email)
                            .subscribe(() => {
                              Swal.fire({

                                position: "center",
                                icon: "success",
                                title: "Verification email has been sent",
                                text: "Please check your email and click on the link sent to verify your account.",
                                showCloseButton: true,
                                showConfirmButton: false,
                              }).then(() => {
                                this.isLoading = false;
                                this.isDisabledCheck = false;
                              });
                            });
                        });
                      },
                    }).then(() => {
                      this.isLoading = false;
                      this.isDisabledCheck = false;
                    });
                  },
                  (error) => {

                    this.isLoading = true;
                    this.isDisabledCheck = true;

                    Swal.fire({
                      position: "center",
                      icon: "error",
                      title: "Too many attempts",
                      text: "Please try agin later to verify your email",
                      showCloseButton: true,
                    }).then(() => {
                      this.isLoading = false;
                      this.isDisabledCheck = false;
                    });
                  }
                );
            }
            if (result.dismiss === Swal.DismissReason.close) {
              this.isLoading = false;
              this.isDisabledCheck = false;
            }
          });
        } else {
          // Email verified

          this.isLoading = true;
          this.isDisabledCheck = true;

          this.googleAuthService
            .SignIn(credentials.Email, credentials.Password)
            .then((result) => {

              this.userService.login(credentials).subscribe((response) => {
                const workpass_token = response.data.token;

                this.isLoading = true;
                this.isDisabledCheck = false;

                this.jwt.saveToken(workpass_token);

                const responseData = {
                  id: response.data.id.toString(),
                  firstName: response.data.firstName,
                  LastName: response.data.lastName,
                };

                this.isLoading = true;
                this.isDisabledCheck = true;

                this.userService.setUserID(responseData.id.toString());
                localStorage.setItem("userID", responseData.id.toString());

                this.userService
                  .getApplicantDetails(responseData.id)
                  .subscribe((response) => {

                    this.isLoading = false;
                    this.isDisabledCheck = false;

                    localStorage.setItem(
                      "applicantDetails",
                      JSON.stringify(response)
                    );

                    if (response.isProfileComplete == false) {
                      this.router.navigate(["/user/applicant-profilling"]);
                    } else {
                      this.router.navigate(["/user/home"]);
                    }
                  });
              });
            })
            .catch((error) => {
              this.isLoading = false;
              this.isDisabledCheck = false;

              switch (error.code) {
                case "auth/wrong-password":
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Incorrect Password",
                    text: "The password you entered is incorrect. Please try again.",
                    showConfirmButton: false,
                    showCloseButton: true,
                  }).then(() => {
                    this.isLoading = false;
                    this.isDisabledCheck = false;
                  });
                  break;
                case "auth/user-not-found":
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "User cannot be found",
                    showConfirmButton: false,
                    showCloseButton: true,
                  }).then(() => {
                    this.isLoading = false;
                    this.isLoadingCheck = false;
                    this.isDisabledCheck = false;
                  });
                  break;
                case "auth/too-many-requests":
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Maximum Attempts",
                    text: "You attempted too many times.Please try again later",
                    showConfirmButton: false,
                    showCloseButton: true,
                  }).then(() => {
                    this.isLoading = false;
                    this.isDisabledCheck = false;
                  });

                  break;
              }
            });
        }
      })
      .catch((error) => {
        this.isLoading = false;
        this.isDisabledCheck = false;

        switch (error.code) {

          case "auth/wrong-password":
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Incorrect password",
              text: "The password you entered is incorrect. Please try again.",
              showConfirmButton: false,
              showCloseButton: true,
            }).then(() => {
              this.isLoading = false;
              this.isDisabledCheck = false;
            });
            break;
          case "auth/user-not-found":
            Swal.fire({
              position: "center",
              icon: "error",
              title: "User cannot be found",
              showConfirmButton: false,
              showCloseButton: true,
            }).then(() => {
              this.isLoading = false;
              this.isLoadingCheck = false;
              this.isDisabledCheck = false;
            });
            break;
          case "auth/too-many-requests":
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Exceeded maximum attempts limit",
              text: "You have reached the maximum number of attempts allowed. Please try again later.",
              showConfirmButton: false,
              showCloseButton: true,
            }).then(() => {
              this.isLoading = false;
              this.isDisabledCheck = false;
            });

            break;
        }
      });
  }

  onNavigateDashboard() {
    if (this.userData.isProfileComplete == true) {
      this.router.navigate(["user/home"]);
    } else {
      this.router.navigate(["/user/applicant-profilling"]);
    }
  }
}
